<template>
  <main>
    <Transition name="fade">
      <Loader v-if="!$beet.isReady" />
    </Transition>
    <template v-if="$beet.isReady">
      <Banner :content="bannerContent" />
      <DropdownCardsSection :content="faqQuestionsSection" />
    </template>
  </main>
</template>

<script>
import Banner from '@/components/sections/Banner.vue'
import DropdownCardsSection from '@/components/sections/DropdownCardsSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  mixins: [PageMetaMixin],
  name: 'Hotel',
  components: {
    Banner,
    DropdownCardsSection,
    Loader,
  },
  computed: {
    bannerContent() {
      return {
        image: {
          original: 'https://assets.boitebeet.com/hotel-ophelia/68/faq-banner.jpg',
          data: { alt: '' },
        },
        subtitle: this.$t('faq.subtitle'),
        title: this.$t('faq.title'),
      }
    },
    faqQuestionsSection() {
      return {
        questions: Object.values(this.$beet.faq),
        text: this.$beet.options.faq.content,
      }
    },
  },
}
</script>
